import BaseModelAPI from '../BaseModelAPI';

export default class Rack extends BaseModelAPI {
	static entity = 'printqr';
	static entityName = 'printqr';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.code = '';
		this.filename = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printQr(this_, id, prefix) {
		return this_.$http.get(`${this.entityName}/print/${id}?prefix=${prefix}`)
			.then(function (response) {
				if (response != null) {
					let result = response.data;
					return result;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}